import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { async, BehaviorSubject, lastValueFrom, observable, Observable, of, Subject, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import qnsbnurlAPI from '../services/qn-sbn-API-url';
// import { OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';
import { Router } from '@angular/router';

import { AuthService } from '../../../core/auth/auth.service';
import { QnSbnDataServiceService } from './qn-sbn-data-service.service';
import { AppUtils } from '../utlis/app-utils';
import { affiliateFallbackData } from './affiliates-data';
import { SnackbarService } from './snackbar.service';
import { NotificationDetailsService } from '../notification/notification-details/notification-details.service'

@Injectable({
  providedIn: 'root'
})
export class QnSbnService {
  public accessToken: string = '';
  // public fileSizeU: string;
  public notificationID: any;
  public notificationsData: any;
  public userRole: any = {
    CreateNotification: true,
    SendNotification: true,
    UserAdmin: false,
    ViewNotification: true
  };
  public userData: any;
   public UserCountries: any = [];
  public contactsData: any;
  public openEditor$ = new Subject<any>();
  public templateSaved$ = new Subject<any>();
  // public apiKey = environment.appApiKey;
  public baseUrl = environment.appApiUrl;
  public header = {};

  // to toggle render of Unauth msg in notification.component.html
  public isAuthUser: boolean = false;
  public isError: boolean = false;
  public errorMsg: any;



  public constructor(public http: HttpClient, private snackBarNotification: SnackbarService, public appUtil: AppUtils, public router: Router, private authService: AuthService, public _QnSbnDataService: QnSbnDataServiceService,
    public notificationDetailsService: NotificationDetailsService) {

  }

  public templateSelected$ = new Subject<any>();

  emitSelectedTemplate(data: any) {
    this.templateSelected$.next(data);
  }

  private templateDataSource = new BehaviorSubject<any>(null);
  templateData$ = this.templateDataSource.asObservable();

  private savedTemplateSource = new Subject<any>();
  savedTemplate$ = this.savedTemplateSource.asObservable();

  sendTemplateData(data: any): void {
    this.templateDataSource.next(data);
  }

  emitSavedTemplate(data: any): void {
    this.savedTemplateSource.next(data);
  }

  // qn-sbn-service.service.ts
  private templateSubject = new Subject<any>();
  template$ = this.templateSubject.asObservable();

  private templateEditSubject = new Subject<any>();
  templateDatas$ = this.templateEditSubject.asObservable();

  setTemplate(data: any) {
    this.templateSubject.next(data);
  }

  editTemplate(data: any) {
    this.templateEditSubject.next(data);
  }


  private getHeaders(): HttpHeaders {
    const idToken = this.authService.getIdToken();  // Get the token from AuthService
    return new HttpHeaders({
      'Authorization': idToken ? `Bearer ${idToken}` : '',
      'Content-Type': 'application/json',
    });
  }
  // public getLocalStorageItem(text:string) {
  //   for (let i = 0; i < localStorage.length; i++) {
  //     const lsKeyName: string = localStorage.key(i);
  //     if (lsKeyName.includes(text)) {
  //       return localStorage.getItem(lsKeyName);
  //     }
  //   }
  // }

  public setAccessToken(access_token: string) {
    this.accessToken = access_token;
  }

  public setLocalNotificationID(notificationId: any) {
    this.notificationID = notificationId;
  }

  public getLocalNotificationID() {
    return this.notificationID;
  }

  public getQnSbnService(url: string): Observable<any> {
    const headers = this.getHeaders();
    return this.http.get(url, { headers });
  }

  public postQnSbnService(url: string, data?: any): Observable<any> {
       const headers = this.getHeaders(); 
    return this.http.post(url, data, { headers });
  }

  public putQnSbnService(url: string, data?: any): Observable<any> {
       const headers = this.getHeaders();
    return this.http.put(url, data, { headers });
  }

  dataToBeSaveOnS3(saveNCloseData, fileToBeUpload, notificationIdP?, isLastFile?, isSendNotification?) {

    if (fileToBeUpload) {
      let filename = fileToBeUpload.name;
      this.getQnSbnService(this.baseUrl + qnsbnurlAPI.getSignedURLForFileUpload + filename + "&NotificationId=" + notificationIdP + "&Verify=" + false).subscribe(async res => {
        if (res) {

          let uploadURL = res['body'];
          const httpOptions = {
            headers: new HttpHeaders({
              "Content-Type": "application/octet-stream",
              "Accept": '*/*'
            })
          };

          this.http.put(uploadURL, fileToBeUpload, httpOptions).subscribe(d => {
            this.getQnSbnService(this.baseUrl + qnsbnurlAPI.getSignedURLForFileUpload + filename + "&NotificationId=" + notificationIdP + "&Verify=" + true).subscribe(async res => {
              if (res) {
                if (isLastFile && isSendNotification) {
                  sessionStorage.setItem('reloadOverview', 'true');
                  this.sendNotificationData(saveNCloseData).subscribe(res => {
                    this._QnSbnDataService.resetAll();
                    this.router.navigateByUrl('/notification');
                    this.snackBarNotification.snackBarMessage('positive', 'Notification sent successfully');
                  }, (error: HttpErrorResponse) => {
                    this.httpErrorHandler(error, 'Sending local notification failed.');
                  })
                } else if (isLastFile && isSendNotification === false) {
                  sessionStorage.setItem('reloadOverview', 'true');
                  this.saveNCloseNotificationData(saveNCloseData).subscribe(res => {
                    this._QnSbnDataService.resetAll();
                    this.router.navigateByUrl('/notification');
                    this.snackBarNotification.snackBarMessage('positive', 'Local notification saved successfully');
                  }, (error: HttpErrorResponse) => {
                    this.httpErrorHandler(error, 'Local notification not saved successfully');
                  })
                }
              } else {
                this.snackBarNotification.snackBarMessage('alarm', 'Send or Save local notification failed.');
              }
            },
              (err) => {
                this.snackBarNotification.snackBarMessage('alarm', 'Local uploaded File size is Zero and Send Notification Failed');
              });
          },
            (err) => {
              this.snackBarNotification.snackBarMessage('alarm', 'Send or Save local notification failed.');
            });
        }
      });
    }
  }

  async dataToBeSaveOnS3Only(fileToBeUpload: any, notificationIdP?: any): Promise<any> {
  if (!fileToBeUpload) return null;

  let filename = fileToBeUpload.name;

  try {
    // 1️⃣ Get signed URL
    const res1: any = await lastValueFrom(
      this.getQnSbnService(
        this.baseUrl + qnsbnurlAPI.getSignedURLForFileUpload + filename +
        "&NotificationId=" + notificationIdP + "&Verify=false"
      )
    );

    const uploadURL = res1?.body;

    // 2️⃣ Upload file
    await lastValueFrom(
      this.http.put(uploadURL, fileToBeUpload, {
        headers: new HttpHeaders({
          "Content-Type": "application/octet-stream",
          "Accept": "*/*"
        })
      })
    );

    // 3️⃣ Verify upload
    const res2: any = await lastValueFrom(
      this.getQnSbnService(
        this.baseUrl + qnsbnurlAPI.getSignedURLForFileUpload + filename +
        "&NotificationId=" + notificationIdP + "&Verify=true"
      )
    );

    return res2; // ✅ NOW THIS WORKS

  } catch (err) {
    throw err;
  }
}

  uniqueIdPiosDocSearch(urlSuffix: any): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.PIOSMetadata + urlSuffix;
    const headers = this.getHeaders();
    return this.http.get(apiurl, { headers });
  }

  addNewAttachmentsInNotification(data: any): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.addTheUploadedFileIntoNotification;
    const headers = this.getHeaders();
    return this.http.post(apiurl, data, { headers });
  }
  
  removeAttachmentsFromNotification(data: any): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.removeTheAttachmentFromNotification;
    const headers = this.getHeaders();
    return this.http.post(apiurl, data, { headers });
  }

  notificationDocPiosDocSearch(urlSuffix: any): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.PIOSMetadata + urlSuffix;
    const headers = this.getHeaders();
    return this.http.get(apiurl, { headers });
  }

  addNewRecipientList(data: any): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.contactNotification;
    const headers = this.getHeaders();
    return this.http.post(apiurl, data, { headers });
  }

  createNotificationUniqueId(data: any): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.globalNotification;
    const headers = this.getHeaders();
    return this.http.post(apiurl, data, { headers });
  }

  // saveNCloseNotificationData(data: any): Observable<any> {
  //   const apiurl = this.baseUrl + qnsbnurlAPI.globalNotification;
  //   const headers = this.getHeaders();
  //   return this.http.get(apiurl, {
  //     headers,
  //     params: data
  //   });
  // }

   saveNCloseNotificationData(data:any): Observable<any> {
    const headers = this.getHeaders();
    const apiurl = this.baseUrl + qnsbnurlAPI.globalNotification;
    return this.http.put(apiurl, data, { headers });
  }


  sendNotificationData(data: any): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.sendNotificationAPI;
    const headers = this.getHeaders();
    return this.http.put(apiurl, data, { headers });
  }

  public postResendNotifications(data: any): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.resendNotificationAPI;
    const headers = this.getHeaders();
    return this.http.post(apiurl, data, { headers });
  }

  public postBulkResendNotifications(data: any): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.bulkResendNotificationAPI;
    const headers = this.getHeaders();
    return this.http.post(apiurl, data, { headers });
  }

  /* Get FeedBack Data start*/
  //   getFeedbackDetails(notificationId:string, contactNotificationId: Array<any>): Observable<any> {
  //     const FeedbackDetailsApi = {
  //       NotificationId : notificationId,
  //       ContactNotificationIds: contactNotificationId
  //     }
  //     const FeedbackDetailsJson= JSON.stringify(FeedbackDetailsApi);
  //     const apiurl = this.baseUrl + qnsbnurlAPI.getFeedBackDetails;
  //     return this.http.post(apiurl, FeedbackDetailsJson);
  //   }
  //   /* Get FeedBack Data start End*/

  //   /*Set Notification status Complete*/
  setNotificationStatus(stausData: any): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.setNotificationURL;
    const headers = this.getHeaders();
    return this.http.put(apiurl, stausData, { headers });
  }

   //   /*Set Notification status Cancelled*/
  cancelNotification(notificationId: string, cancelReason: string): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.cancelNotification;
    const headers = this.getHeaders();
    return this.http.post(apiurl, { notificationId, cancelReason }, { headers });
  }
  // /*Set Notification status Complete*/

  // downloadPiosDocumentApi(globalNotificationId, fileExtension) {
  //   const apiurl = this.baseUrl + qnsbnurlAPI.downloadDocument + globalNotificationId;
  //   this.appUtil.fetchDoc(apiurl, this.accessToken, fileExtension);
  // }

  // downloadLocalAttachmentApi(filename: string, notificationId: string) {
  //   const apiurl = this.baseUrl + qnsbnurlAPI.downloadAttachment + "Filename=" + filename + "&NotificationId=" + notificationId;
  //   this.getQnSbnService(apiurl).subscribe(res => {
  //     if (res) {
  //       let downloadURL = res['body'];
  //       this.appUtil.fetchDoc(downloadURL, '', '', filename);
  //     }
  //   });
  // }

  // downloadLSOAttachmentApi(filename: string, notificationId: string, contactNotificationId: string) {
  //   const apiurl = this.baseUrl + qnsbnurlAPI.downloadAttachment
  //     + "Filename=" + filename
  //     + "&NotificationId=" + notificationId
  //     + "&ContactNotificationId=" + contactNotificationId;
  //   this.getQnSbnService(apiurl).subscribe(res => {
  //     if (res) {
  //       let downloadURL = res['body'];
  //       this.appUtil.fetchDoc(downloadURL, '', '', filename);
  //     }
  //   });
  // }

  downloadPiosDocumentApi(globalNotificationId, fileExtension) {
    const apiurl = this.baseUrl + qnsbnurlAPI.downloadDocument + globalNotificationId;
    const token = this.authService.getIdToken();
    this.appUtil.fetchDoc(apiurl, '', token, fileExtension);
  }

 downloadLocalAttachmentApi(filename:string, notificationId:string, accountNotificationId?: string, attachment?: string) {
    let apiurl;
    if(accountNotificationId && attachment){
      apiurl = this.baseUrl + qnsbnurlAPI.downloadAttachment + "Filename="+filename+"&NotificationId="+notificationId+"&AccountNotificationId="+accountNotificationId+"&Attachment="+attachment;
    } else {
      apiurl = this.baseUrl + qnsbnurlAPI.downloadAttachment + "Filename="+filename+"&NotificationId="+notificationId;
    }
    this.getQnSbnService(apiurl).subscribe(res => {
      if(res){
        let downloadURL = res['body'];
        fetch(downloadURL)
          .then(response => response.blob())
          .then(blob => {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          });
      }
    });
  }

  downloadLSOAttachmentApi(filename:string, notificationId:string, contactNotificationId:string) {
    const apiurl = this.baseUrl + qnsbnurlAPI.downloadAttachment 
    +"Filename="+filename
    +"&NotificationId="+notificationId
    +"&ContactNotificationId="+contactNotificationId;
    this.getQnSbnService(apiurl).subscribe(res=>{
      if(res){
        let downloadURL = res['body'];
        fetch(downloadURL)
          .then(response => response.blob())
          .then(blob => {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          });

      }
    });
  }


  qnSbnNotificationInitCall(): Observable<any> {

    const apiurl = this.baseUrl + qnsbnurlAPI.userDetails;
    const headers = this.getHeaders();
    return this.http.get(apiurl, { headers });

  }

  getNotificationOverviewData(type: any, status: any, country: any) {
    const apiurl = this.baseUrl
      + qnsbnurlAPI.notificationDetail
      + "?typeFilter=" + type
      + "&statusFilter=" + status
      + "&countryFilter=" + country;
    const headers = this.getHeaders();
    return this.http.get(apiurl, { headers });
  }

  getNotificationContactDetails(notificationId: string): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.contactDetails + notificationId;
    const headers = this.getHeaders();
    return this.http.get(apiurl, { headers });

  }

  setNotificationData(data: any) {
    this.notificationsData = data;
    // Persist to sessionStorage to survive navigation
    try {
      sessionStorage.setItem('cachedNotificationData', JSON.stringify(data));
      sessionStorage.setItem('reloadOverview', 'false');
    } catch (e) {
      console.warn('Failed to cache notification data in sessionStorage:', e);
    }
  }

  getNotificationData() {
    // First try to get from memory
    if (this.notificationsData) {
      return this.notificationsData;
    }
    
    // If not in memory, try to restore from sessionStorage
    const cachedData = sessionStorage.getItem('cachedNotificationData');
    if (cachedData) {
      this.notificationsData = JSON.parse(cachedData);
      return this.notificationsData;
    }
    
    return undefined;
  }

  setUserData(data: any) {
    if (Array.isArray(data)) {
      if (data[0].userGroupData && data[0].userGroupData.permissions) {
        this.userData = data[0].userGroupData;
        this.userRole = data[0].userGroupData.permissions;
      }
    } else {
      if (data.userGroupData && data.userGroupData.permissions) {
        this.userData = data.userGroupData;
        this.userRole = data.userGroupData.permissions;
      }
    }

    // Populate UserCountries so getUserCountries() returns the correct value
    if (this.userData?.countries) {
      this.UserCountries = Array.isArray(this.userData.countries)
        ? this.userData.countries
        : this.userData.countries.split(',');
    }

    sessionStorage.setItem('UserRole', JSON.stringify(this.userRole));
    sessionStorage.setItem('UserCountries', this.userData.countries);
  }

  getUserData() {
    return this.userRole;
  }

  getUserAllData() {
    return this.userData;
  }

  EditCustomerData(CustomerDetails: any): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.contactNotification;
    const headers = this.getHeaders();
    return this.http.put(apiurl, CustomerDetails, { headers });
  }

  httpErrorHandler(error: any, errMessage: string) {
    if (error.status === 401) {
      this.snackBarNotification.snackBarMessage('alarm', 'Token Expire, Please login again.');
      setTimeout(function () {
        window.location.reload();
      }, 2000);
    } else {
      const apiMessage = this.extractErrorMessage(error);
      this.snackBarNotification.snackBarMessage('alarm', apiMessage || errMessage);
    }
  }

  private extractErrorMessage(error: any): string | null {
    const raw = error?.error?.message || error?.error?.errorMessage || (typeof error?.error === 'string' ? error.error : null);
    if (!raw) return null;
    return raw.replace(/^\[\d+\]\s*/, '');
  }

  public getNotificationLanguage(country: string): string {
    const affiliateData = affiliateFallbackData;
    const notificationCountry = country?.toLowerCase();
    const chosenAffiliate = affiliateData.find(
      affiliate => affiliate.affiliate.toLowerCase() === notificationCountry
    );
    return chosenAffiliate?.defaultLanguage || 'en_US';
  }


  public getMessageTemplate(notificationType: string, language: string): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.getMessageTemplate + '&notificationtype=' + notificationType + '&language=' + language;
    const headers = this.getHeaders();
    return this.http.get(apiurl, { headers });
  }

  public getReminderTemplate(notificationType: string, language: string): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.getReminderTemplate + '&notificationtype=' + notificationType + '&language=' + language;
    const headers = this.getHeaders();
    return this.http.get(apiurl, { headers });
  }

  public createUpdateMessageTemplate(data: any): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.addUpdateMessageTemplate;
    const headers = this.getHeaders();

    return this.http.post(apiurl, data, { headers });
  }


  public deleteMessageTemplate(templateId: string): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.deleteMessageTemplate + templateId;
    const headers = this.getHeaders();
    return this.http.get(apiurl, { headers });
  }

  public fetchCSV(data: any): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.fetchCsvReport;
    const headers = this.getHeaders();
    return this.http.post(apiurl, data, { headers });
  }

  downloadEmailEvidenceApi(notificationId: string, filename: string, CustomerContactEmail: string) {
    const apiurl = this.baseUrl
      + qnsbnurlAPI.downloadEmailEvidence
      + "?NotificationId=" + notificationId
      + "&Filename=" + encodeURIComponent(filename)
      + "&CustomerContactEmail=" + encodeURIComponent(CustomerContactEmail);

    this.getQnSbnService(apiurl).subscribe(
      res => {
        let downloadURL = res['body'];
        this.appUtil.fetchDoc(downloadURL, '', '', filename + '.pdf');
      }
    );
  }

  public deleteDraftNotification(notificationID: string): Observable<any> {
    const headers = this.getHeaders();
    const apiurl = this.baseUrl + qnsbnurlAPI.deleteDraftNotification + notificationID;
    return this.http.get(apiurl, { headers });
  }


  public fileAckSaveOnS3(fileToBeUpload, contactNotificationId, notificationId): Observable<any> {
    if (fileToBeUpload) {
      let filename = fileToBeUpload.name;
      this.getQnSbnService(this.baseUrl + qnsbnurlAPI.getSignedURLForCustomerFileUpload + "?Filename=" + filename + "&ContactNotificationId=" + contactNotificationId + "&NotificationId=" + notificationId + "&Verify=" + false).subscribe(async res => {
        if (res) {
          let uploadURL = res['body'];
          const httpOptions = {
            headers: new HttpHeaders({
              "Content-Type": "application/octet-stream",
              "Accept": '*/*'
            })
          };
          this.http.put(uploadURL, fileToBeUpload, httpOptions).subscribe(d => {
            this.getQnSbnService(this.baseUrl + qnsbnurlAPI.getSignedURLForCustomerFileUpload + "?Filename=" + filename + "&ContactNotificationId=" + contactNotificationId + "&NotificationId=" + notificationId + "&Verify=" + true).subscribe(
              async res => {
                if (res) {
                  this._QnSbnDataService.resetAll();
                }
              },
              (error: HttpErrorResponse) => {
                this.snackBarNotification.snackBarMessage('alarm', `Please try again later`);
                // this.oneSnackBar.open(`Please try again later`, OneSnackBarType.ERROR, '', { duration: 5000 });
                return;
              }
            );
          },
            (error: HttpErrorResponse) => {
              this.snackBarNotification.snackBarMessage('alarm', `Failed to upload file. Please try again later.`);
              return;
            });
        }
      });
    }
    return of(true);
  }

  public feedbackApi(feedbackApiJson) {
    const apiurl = this.baseUrl + qnsbnurlAPI.feedbackAckApi;
    const headers = this.getHeaders();
    return this.http.post(apiurl, feedbackApiJson, { headers });
  }

  EditAccountData(AccountDetails: any): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.editAccountData;
    const headers = this.getHeaders();
    return this.http.put(apiurl, AccountDetails, { headers });
  }

  public getAccountList(notificationId: string): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.getAccountList + notificationId;
    const headers = this.getHeaders();
    return this.http.get(apiurl, { headers });
  }

  public getContactList(accountNotificationId: string): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.getContactList + accountNotificationId;
    const headers = this.getHeaders();
    return this.http.get(apiurl, { headers });
  }

  public getNotificationAuditTrailList(notificationId: string): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.getNotificationAuditTrailData + notificationId;
    const headers = this.getHeaders();
    return this.http.get(apiurl, { headers });
  }

  public getContactNotificationAuditTrailList(contactNotificationId: string): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.getContactNotificationAuditTrailData + contactNotificationId;
    const headers = this.getHeaders();
    return this.http.get(apiurl, { headers });
  }

  public getAccountNotificationAuditTrailList(accountNotificationId: string): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.getAccountNotificationAuditTrailData + accountNotificationId;
    const headers = this.getHeaders();
    return this.http.get(apiurl, { headers });
  }

  public getRexSapTaskId(
    countryCode: string,
    accountsSource: string,
    contactsSource: string,
    instrumentMaterialNumber: string,
    reagentMaterialNo: string,
    materialBatchNo: string,
    dateFrom: Date | null,
    dateTo: Date | null,
    contactAttrType: string,
    contactAttrValue: string,
    contactRole: string,
    instrumentStatus: string,
    shipPartnerRole:[]
  ): Promise<any> {

    const dateFromStr = this.formatDateRexis(dateFrom);
    const dateToStr = this.formatDateRexis(dateTo);

    const apiurl = this.baseUrl + qnsbnurlAPI.getRexisSapDataUrl +
      `countryCode=${countryCode || ''}&` +
      `accountsSource=${accountsSource || ''}&` +
      `contactsSource=${contactsSource || ''}&` +
      `instrumentMaterialNumber=${instrumentMaterialNumber || ''}&` +
      `reagentMaterialNo=${reagentMaterialNo || ''}&` +
      `materialBatchNo=${materialBatchNo || ''}&` +
      `dateFrom=${dateFromStr || ''}&` +
      `dateTo=${dateToStr || ''}&` +
      `contactAttrType=${contactAttrType || ''}&` +
      `contactAttrValue=${contactAttrValue || ''}&` +
      `contactRole=${contactRole || ''}&` +
      `instrumentStatus=${instrumentStatus || ''}&` +
      `shipPartnerRole=${shipPartnerRole || ''}`;

    const headers = this.getHeaders();
    return this.http.get(apiurl, { headers }).toPromise();

  }

  public formatDateRexis(x: Date | null | undefined): string | null {
    if (x) {
      let y = x.getFullYear().toString();
      let m = (x.getMonth() + 1).toString();
      let d = x.getDate().toString();
      if (d.length == 1) d = '0' + d;
      if (m.length == 1) m = '0' + m;
      return y + m + d;
    }
    return null;
  }


  public getRexSapPolling(mainTaskId: string): Promise<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.getRexSapPolling + mainTaskId
    const headers = this.getHeaders();
    return this.http.get(apiurl, { headers }).toPromise();

  }

  public saveInternalNote(data: any): Observable<any> {
    const headers = this.getHeaders();
    const apiurl = this.baseUrl + qnsbnurlAPI.internalNotesAPI;
    return this.http.post(apiurl, data, { headers });
  }

  public deleteContact(data: any): Observable<any> {
    const headers = this.getHeaders();
    const apiurl = this.baseUrl + qnsbnurlAPI.deleteContactAPI;
    return this.http.post(apiurl, data, { headers });
  }

  
  public emailReportDashboard(emailDetailsJson): Observable<any> {
    const headers = this.getHeaders();
    const apiurl = this.baseUrl + qnsbnurlAPI.generateEmailReportAPI;
    return this.http.post(apiurl, emailDetailsJson, { headers });
  }

  public emailReportDetails(emailReportJson): Observable<any> {
    const headers = this.getHeaders();
    const apiurl = this.baseUrl + qnsbnurlAPI.generateemailreportdetailsAPI;
    return this.http.post(apiurl, emailReportJson, { headers });
  }

  public statisticsReportDashboard(dashboardJson): Observable<any> {
    const headers = this.getHeaders();
    const apiurl = this.baseUrl + qnsbnurlAPI.generatestatisticsreportAPI;
    return this.http.post(apiurl, dashboardJson, { headers });
  }

  getUserCountries() {
    return this.UserCountries;
  }

  notificationReminderHelper(notificationId: string): Observable<any> {
    const headers = this.getHeaders();
    const apiurl = `${this.baseUrl}${qnsbnurlAPI.notificationReminderHelper}?notificationid=${encodeURIComponent(notificationId)}`;
    return this.http.get(apiurl, { headers });
  }

  viewReminderLocal(notificationId: string): Observable<any> {
     const headers = this.getHeaders();
    const apiurl = `${this.baseUrl}${qnsbnurlAPI.viewReminderLocal}?notificationid=${encodeURIComponent(notificationId)}`;
    return this.http.get(apiurl, { headers });
  }

  public createNotificationVersion(notificationId: string): Observable<any> {
    const headers = this.getHeaders();
    const requestBody = { oldNotificationId: notificationId };
    const apiurl = this.baseUrl + qnsbnurlAPI.createNotificationVersion;
    return this.http.post(apiurl, requestBody, { headers });
  }

  public createReminders(payload: any): Observable<any> {
    const headers = this.getHeaders();
    const apiurl = this.baseUrl + qnsbnurlAPI.createReminders;
    return this.http.post(apiurl, payload, { headers });
  }

}